import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
export function FinalCTASection() {
  const [ref, vis] = useReveal();
  // 7 min 50 sec countdown
  const [timeLeft, setTimeLeft] = useState(7 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 7 * 60 + 50;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-4 sm:px-6 border-t border-white/5" data-id="element-117">
      <div className="container mx-auto max-w-3xl" data-id="element-118">
        <div ref={ref} className={`reveal text-center ${vis ? 'is-visible' : ''}`} data-id="element-119">
          <div className="mb-8 flex justify-center items-center gap-2 text-[#eab308] font-bold text-lg md:text-xl tracking-widest uppercase" data-id="element-120">
            <span data-id="element-121">⏰ EL PRECIO CIERRA EN:</span>
            <span className="font-serif bg-black px-3 py-1 rounded border border-[#eab308]/30" data-id="element-122">
              {hours.toString().padStart(2, '0')} hs :{' '}
              {minutes.toString().padStart(2, '0')} min :{' '}
              {seconds.toString().padStart(2, '0')} seg
            </span>
          </div>

          <div className="space-y-6 mb-10" data-id="element-123">
            {/* Premium Compact */}
            <div className="bg-gradient-to-r from-[#111111] to-[#0a0a0a] border-2 border-[#eab308]/50 rounded-xl p-6 text-left relative overflow-hidden" data-id="element-124">
              <div className="absolute top-0 right-0 bg-[#eab308] text-black font-bold text-[10px] px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-125">
                ⭐ RECOMENDADO
              </div>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1 pr-24" data-id="element-126">
                🏆 MEGAPACK + KIT PROFESIONAL
              </h3>
              <p className="text-[#eab308] font-bold text-sm mb-4" data-id="element-127">
                6 Tomos + 6 Bonos + Módulo Consultorio Avanzado
              </p>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-128">
                <div className="flex items-center gap-3" data-id="element-129">
                  <span className="text-gray-500 line-through text-lg font-bold" data-id="element-130">
                    $89.000
                  </span>
                  <p className="text-3xl font-extrabold text-[#eab308] leading-none" data-id="element-131">
                    $27.990 <span className="text-sm" data-id="element-132">ARS</span>
                  </p>
                </div>
                <a href="https://pagos.academiaholisticaargentina.com/cart/48480180371673:1" target="_blank" rel="noopener noreferrer" className="inline-block py-3 px-6 rounded-lg text-[#0f0f1a] font-bold text-sm tracking-widest uppercase text-center transition-all bg-[#eab308] hover:bg-[#d4a017] shadow-[0_0_20px_rgba(234,179,8,0.3)] hover:-translate-y-1" data-id="element-133">
                  → QUIERO EL MEGAPACK + KIT PROFESIONAL
                </a>
              </div>
            </div>

            {/* Base Compact */}
            <div className="bg-[#111111] border border-white/10 rounded-xl p-6 text-left" data-id="element-134">
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1" data-id="element-135">
                📘 MEGAPACK BIODESCODIFICACIÓN INTEGRAL
              </h3>
              <p className="text-gray-400 font-bold text-sm mb-4" data-id="element-136">
                6 Tomos + 6 Bonos · Síntoma · Conflicto · Sanación
              </p>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-137">
                <div className="flex items-center gap-3" data-id="element-138">
                  <span className="text-gray-500 line-through text-lg font-bold" data-id="element-139">
                    $69.000
                  </span>
                  <p className="text-3xl font-extrabold text-white leading-none" data-id="element-140">
                    $19.990 <span className="text-sm" data-id="element-141">ARS</span>
                  </p>
                </div>
                <a href="https://pagos.academiaholisticaargentina.com/cart/48480179650777:1" target="_blank" rel="noopener noreferrer" className="inline-block py-3 px-6 rounded-lg text-white font-bold text-sm tracking-widest uppercase text-center transition-all bg-white/10 hover:bg-white/20 border border-white/20 hover:-translate-y-1" data-id="element-142">
                  → QUIERO MI MEGAPACK
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-gray-400 text-xs sm:text-sm font-medium" data-id="element-143">
            <span className="flex items-center gap-1.5" data-id="element-144">
              🔒 Pago 100% seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-145">
              ⚡ Acceso en 5 minutos
            </span>
            <span className="flex items-center gap-1.5" data-id="element-146">
              🛡️ Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-147">
              💳 Mercado Pago | Tarjeta | Transferencia
            </span>
          </div>
        </div>
      </div>
    </section>;
}